import BusinessCard from "@/pages/home/components/BusinessCard";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <BusinessCard />
    </div>
  );
}